import styled from '@emotion/styled';
import { letterSpacing, fontSize } from 'styled-system';
import { Link as RouterLink } from 'react-router-dom';
import { Link as RooLink } from '@qga/roo-ui/components';

const StyledLink = styled(RooLink)`
  ${letterSpacing}
  ${fontSize}
`;

const Link = (props) => <StyledLink as={RouterLink} {...props} />;

export default Link;
